/* RESPONSIBLE TEAM: team-proactive-support */
import { helper } from '@ember/component/helper';
import { objectNames } from 'embercom/models/data/matching-system/matching-constants';

export function contentType(objectType) {
  return objectNames[objectType];
}

export default helper(contentType);
